import { useState } from "react"
import axios from "axios"
import swal from "sweetalert"
import Layout from "../components/layout"
import { getIskibrisUrl } from "../lib/api"
import WhatsappContact from "../components/WhatsappContact"
import { TextField, Button, TextareaAutosize } from "@mui/material"

const Contact = () => {
  const [name, setName] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")

  const url = getIskibrisUrl("/api/contact")
  const handleSubmit = event => {
    event.preventDefault()

    const messageForm = {
      full_name: name,
      email: email,
      phone_number: phoneNumber,
      message: message
    }

    axios
      .post(url, messageForm)
      .then(res => {
        swal("Teşekkürler!", "Mesajınız iletilmiştir.", "success")
        setName("")
        setPhoneNumber("")
        setEmail("")
        setMessage("")
      })
      .catch(error => {
        swal("Dikkat", error.message, "warning")
      })
  }

  return (
    <Layout>
      <div className="section section--bg-world">
        <div className="wrapper">
          <h1>İletişim</h1>
        </div>
      </div>
      <div className="section">
        <div className="wrapper">
          <div className="row">
            <div className="row__medium-6">
              <div className="headline">
                Sosyal Medyadan da <br />
                bize ulaşabilirsiniz.
              </div>
              <p>Sadece 1-2 saat içinde bilgi/destek talebinize dönmüş olacağız</p>
            </div>
            <div className="row__medium-6">
              <div className="form-dww">
                <form onSubmit={handleSubmit}>
                  <br></br>
                  <div className="row__paddingTop">
                    <TextField
                      id="name"
                      type="text"
                      style={{ width: "40%" }}
                      label="Ad Soyad"
                      variant="outlined"
                      name="name"
                      value={name}
                      size="small"
                      onChange={e => setName(e.target.value)}
                    />
                  </div>
                  <div className="row__paddingTop">
                    <TextField
                      id="phone_number"
                      label="Telefon Numaranız"
                      variant="outlined"
                      type="text"
                      name="phone_number"
                      size="small"
                      value={phoneNumber}
                      style={{ width: "40%" }}
                      onChange={e => setPhoneNumber(e.target.value)}
                    />
                  </div>
                  <div className="row__paddingTop">
                    <TextField
                      id="email"
                      variant="outlined"
                      style={{ width: "40%" }}
                      label="Email"
                      type="text"
                      name="email"
                      value={email}
                      size="small"
                      onChange={e => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="row__paddingTop">
                    <TextareaAutosize
                      type="text"
                      placeholder="Nasıl yardımcı olabiliriz?"
                      name="message"
                      id=""
                      minRows={10}
                      style={{ width: "40%" }}
                      value={message}
                      onChange={e => setMessage(e.target.value)}
                    />
                  </div>
                  <Button type="submit" className="form__submit" style={{ width: "40%", textTransform: "none", fontSize: "1em" }} size="small" value="Gönder">
                    Gönder
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WhatsappContact />
    </Layout>
  )
}

export default Contact
